import {
  Button,
  Dialog as MuiDialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import Close from "../../../../assets/icons/icon_close_dark.svg";
import { useTranslation } from "react-i18next";
import React from "react";

type InvalidReceiptDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  inputFileRef: React.RefObject<HTMLButtonElement>;
  isAmountMatch?: boolean;
  isDateMatch?: boolean;
  isValidReceipt?: boolean;
};

const InvalidReceiptDialog: React.FC<InvalidReceiptDialogProps> = ({
  open,
  onClose,
  onSave,
  inputFileRef,
  isAmountMatch = true,
  isDateMatch = true,
  isValidReceipt = true,
}) => {
  const { t } = useTranslation();

  const hasIssues = !isAmountMatch || !isDateMatch || !isValidReceipt;

  return (
    <MuiDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontSize="24px" fontWeight={800}>
            {t("payments.edit.invalidReceiptModal.title")}
          </Typography>
          <IconButton onClick={onClose}>
            <img alt="" src={Close} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2, fontWeight: 500 }}>
          {t("payments.edit.invalidReceiptModal.intro")}
        </DialogContentText>

        {hasIssues && (
          <Box component="ul" sx={{ pl: 2, mb: 2 }}>
            {!isAmountMatch && (
              <Typography component="li" sx={{ mb: 1 }}>
                {t("payments.edit.invalidReceiptModal.amountIssue")}
              </Typography>
            )}
            {!isDateMatch && (
              <Typography component="li" sx={{ mb: 1 }}>
                {t("payments.edit.invalidReceiptModal.dateIssue")}
              </Typography>
            )}
            {!isValidReceipt && (
              <Typography component="li" sx={{ mb: 1 }}>
                {t("payments.edit.invalidReceiptModal.invoiceIssue")}
              </Typography>
            )}
          </Box>
        )}

        <DialogContentText sx={{ fontStyle: "italic", mt: 2 }}>
          {t("payments.edit.invalidReceiptModal.reminder")}
        </DialogContentText>

        <DialogContentText sx={{ mt: 2 }}>
          {t("payments.edit.saveChangesPrompt")}
        </DialogContentText>
      </DialogContent>
      <Stack spacing={3} p={"10px"} direction="row" justifyContent="center">
        <Button
          onClick={() => {
            onClose();
            inputFileRef.current?.click();
          }}
          color="success"
        >
          {t("payments.edit.invalidReceiptModal.cancel")}
        </Button>
        <Button
          onClick={() => {
            onClose();
            onSave();
          }}
          color="error"
          autoFocus
        >
          {t("payments.edit.invalidReceiptModal.save")}
        </Button>
      </Stack>
    </MuiDialog>
  );
};

export default InvalidReceiptDialog;
